import Recorder from './recorder.js';

export default class AudioManager {
  constructor(uploadUrl)
  {
    if (typeof Recorder === "undefined") {
      throw "recorder_not_included";
    }

    this.EVENT_SAVED_AUDIO = "savedAudio";
    this.EVENT_UPLOADED_AUDIO = "uploadedAudio";
    this.EVENT_STARTED_RECORDING = "startedRecording";

    this.events = {};
    this.uploadUrl = uploadUrl;
    this.recording = false;
    // Reference au stream (MediaStream)
    this.stream = null;
    // Reference au recorder
    this.recorder = null;
    // References aux audios enregistrés
    this.savedAudio = [];
  }

  // Validation si le user a un device pour enregistrer
  canRecord() {
    let availableDevices = [];
      return navigator.mediaDevices.enumerateDevices().then((devices) => {
      availableDevices = devices.filter((device) => {
        return (device.kind.indexOf("audio") >= 0 && device.kind.indexOf("input") >= 0)
      });

    }).then((response) => {
      return Boolean(availableDevices.length);
    });
  }

  // On enregistre
  record(maxTime) {
    if (this.recording === true) {
      throw "already recording";
    }
    // On recupere les devices du browser, en mode audio
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        this.recording = true;
        // On instancie le contexte, variable selon l'engin
        let AudioContext = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioContext;

        this.stream = stream;

        // On creer le stream
        let input = this.audioContext.createMediaStreamSource(this.stream);

        // On creer le recorder
        this.recorder = new Recorder(input);
        this.recorder.record();

        // Si on veut mettre un temps maximal
        maxTime ? this.timedRecording(maxTime) : void(0);

        this.dispatch(this.EVENT_STARTED_RECORDING, {});
      }).catch((error) => {
        // Si l'acces est refusé
        alert('Vous devez donner acces au micro');
      });
  }

  timedRecording(maxTime) {
    if (maxTime < 300) {
      console.warn("Le temps d'enregistrement est très court.");
    }
    setTimeout(() => {
      this.stopRecording();
    }, maxTime);
  }

  // On arrete l'enregistrement
  stopRecording() {
    this.recorder.stop();
    this.stream.getAudioTracks()[0].stop();
    this.recorder.exportWAV(this.saveAudio.bind(this));
    this.recording = false;
  }

  dispatchSaved(blob) {
    this.dispatch(this.EVENT_SAVED_AUDIO, {
      audio: blob,
      index: this.savedAudio.length
    });
  }

  on(event, callback) {
    if (!this.events[event]) this.events[event] = [];

    this.events[event].push(callback);
  }

  dispatch(event, data) {
    this.events[event].map((callback) => {
      callback(data);
    });
  };

  // On sauvegarde l'audio
  saveAudio(blob) {
    this.savedAudio = [blob];
    //on ajoute a la liste d'audio local
    this.dispatchSaved(blob);
  }

  deleteRecording() {
    this.recorder.clear();
    let event = new Event('recorder_reset');
    document.querySelector('body').dispatchEvent(event);
  }

  upload() {

    const formData = new FormData();

    const uuid = btoa(Math.random()).substr(10, 5);
    const filename = Date.now() + '' + uuid + '.wav';

    // On upload
    fetch(this.uploadUrl, {
        method:"POST",
        body: this.savedAudio[0]
      }).then(response => response.json()).then((data) => {
        this.dispatch(this.EVENT_UPLOADED_AUDIO, data);
      });
  }
}
